import { makeStyles } from '@mui/styles';
import Tab from 'apollo-react/components/Tab';
import Tabs from 'apollo-react/components/Tabs';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import ActionsTable from './components/ActionsTable';
import ColumnsTab from './components/ColumnsTab';
import Distribution from './components/Distribution';
import {
  TAB_ACTION_INDEX,
  TAB_COLUMNS_INDEX,
  TAB_DISTRIBUTION_INDEX,
} from './constants/editor.constants';
import { hasSavedSearchUnsavedChanges } from './selectors/editor.selectors';
import UnsavedChangesPrompt from '../components/UnsavedChangesPrompt';
import { useTranslation } from '../custom-hooks/useTranslation';

const useStyles = makeStyles({
  tablesWrapper: {
    paddingLeft: 5,
  },
  tabContent: {
    backgroundColor: '#fff',
    paddingTop: 10,
  },
});

const SavedSearchDesigner = ({
  showDistribution = true,
  sortFullWidth = false,
  showUnsavedPrompt = true,
}) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [selectedTab, setSelectedTab] = useState(TAB_COLUMNS_INDEX);

  const hasUnsavedChanges = useSelector(hasSavedSearchUnsavedChanges);

  const handleChangeTab = (e, value) => {
    setSelectedTab(value);
  };

  const tabs = useMemo(
    () =>
      [
        { label: 'Columns and Filters' },
        { label: 'Action' },
        { label: 'Distribution', hidden: !showDistribution },
      ].filter((tab) => !tab.hidden),
    [showDistribution]
  );

  return (
    <>
      <div className={classes.tablesWrapper}>
        <Tabs value={selectedTab} onChange={handleChangeTab} truncate>
          {tabs.map(({ label }) => (
            <Tab label={translateString(label)} key={label} />
          ))}
        </Tabs>
        <div className={classes.tabContent}>
          {selectedTab === TAB_COLUMNS_INDEX && <ColumnsTab sortFullWidth={sortFullWidth} />}
          {selectedTab === TAB_ACTION_INDEX && <ActionsTable />}
          {selectedTab === TAB_DISTRIBUTION_INDEX && <Distribution />}
        </div>
      </div>
      {showUnsavedPrompt && <UnsavedChangesPrompt hasUnsavedChanges={hasUnsavedChanges} />}
    </>
  );
};

export default SavedSearchDesigner;
